import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { IconSize, ShIconModule } from '@stylehaven/components';

@Component({
    standalone: true,
    selector: 'digihaven-filter-panel-toggle',
    templateUrl: './filter-panel-toggle.component.html',
    styleUrls: ['./filter-panel-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, ShIconModule]
})
export class FilterPanelToggleComponent {
    readonly iconSize: typeof IconSize = IconSize;

    @Input() open = true;
    @Input() panelId = '';

    @Output() toggled: EventEmitter<void> = new EventEmitter<void>();
}
